<template>
    <ShadowBoxContainer>
        <ListContainer
            :image="require(`@/assets/img/icon_listmytools_step2_information.svg`)"
            imageLabel="General Information"
            heading="Write a detailed description."
            :step="4"
        >

            <div class="ph3 ph4-ns">
                <textarea :value="textAreaText" @input="textAreaText = $event.target.value" rows="8" class="w-100 pa3" v-focus.lazy="lg"></textarea>

                <Info title="Try this:">
                    <div>Find your tool/equipment online to copy and past the official description.</div>
                </Info>
            </div>

        </ListContainer>

        <template slot="actionBar">
            <NavigationButtons :enabledForward="textAreaText !== ''" back="Back" forward="Next" @backClick="$router.push('/add-photos')" @forwardClick="next" />
        </template>

    </ShadowBoxContainer>
</template>

<script>
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import ListContainer from '@/components/list/shared/ListContainer.vue';
import Info from '@/components/list/shared/Info.vue';
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import { focus } from 'vue-focus';
import { mapMutations } from 'vuex';

export default {
    directives: { focus: focus },
    components: {
        ShadowBoxContainer,
        ListContainer,
        Info,
        NavigationButtons
    },
    data() {
        return {
            textAreaText: ''
        };
    },
    methods: {
        ...mapMutations('newListing', ['setDescription']),
        next() {
            this.setDescription(this.textAreaText);
            this.$router.push('/tags');
        }
    },
    computed: {
        lg() {
            return this.$mq === 'lg';
        }
    }
};
</script>
